export const mockIconURL = '/catalog/img/mockicon.svg';

export const technicalWorksIconUrl = '/catalog/img/serviceUnavailable.svg';

export const error500IconUrl = '/catalog/img/500.svg';

export const emptySearchResultIconUrl = '/catalog/img/empty_search_result.svg';

export const emptyAppsListIconUrl = '/catalog/img/empty_apps_list.svg';

export const emptyAppsListFilteredIconUrl =
  '/catalog/img/empty_apps_list_filtered.svg';
